

/**
 * Converts speed in MPH to m/s
 * 
 * @input speed (MPH)
 * @output speed (m/s)
 */
Number.prototype.toMetersPerSecond = function(): number {
    return (this as number) * 1609 / 3600
}

/**
 * Converts speed in m/2 to MPH
 * 
 * @input speed (m/s)
 * @output speed (MPH)
 */
Number.prototype.toMPH = function(): number {
    return (this as number) * 3600 / 1609
}

/**
 * Convert RPM to rad/s
 * 
 * @input angular velocity (RPM)
 * @output angular velocity (rad/s)
 */
Number.prototype.toRadianPerSecond = function(): number {
    return (this as number) * 2 * Math.PI / 60
}

/**
 * Convert rad/s to RPM
 * 
 * @input angular velocity (rad/s)
 * @output angular velocity (RPM)
 */
Number.prototype.toRPM = function(): number {
    return (this as number) * 60 / (2 * Math.PI)
}

/**
 * Convert degrees to radians
 * 
 * @input degrees
 * @output radians
 */
Number.prototype.toRadians = function(): number {
    return (this as number) * Math.PI / 180
}

/**
 * Convert radians to degrees
 * 
 * @input radians
 * @output degrees
 */
Number.prototype.toDegrees = function(): number {
    return (this as number) * 180 / Math.PI
}


export {}